module.exports = __webpack_public_path__ + "img/close.e371cdbe.svg";